export const getAccessToken = () => {
  localStorage.getItem('homeviews_access_token')
}

export const setAccessToken = (token: string) => {
  localStorage.setItem('homeviews_access_token', token)
}

export const removeAccessToken = () => {
  localStorage.removeItem('homeviews_access_token')
}
